import { render, staticRenderFns } from "./DesignDashboard.vue?vue&type=template&id=5772ce8f&scoped=true&"
import script from "./DesignDashboard.vue?vue&type=script&lang=js&"
export * from "./DesignDashboard.vue?vue&type=script&lang=js&"
import style0 from "./DesignDashboard.vue?vue&type=style&index=0&id=5772ce8f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5772ce8f",
  null
  
)

export default component.exports